import ConfirmAssignment from './ConfirmAssignment'

export default ConfirmAssignment
